import Vue from "vue";
import { getPackageNameVersionAndHash } from "./mdc";
import store from "@/store";

export async function packageNotice(item) {
  if (
    store.state.settings.user.profile &&
    store.state.settings.user.profile.notifications &&
    store.state.settings.user.profile.notifications.packageChange
  ) {
    const { title, version } = getPackageNameVersionAndHash(item);

    const versionStr = ` - ${version}`;

    if (item.command.status === "done" && item.command.name === "install") {
      notify(
        `${title} ${versionStr}`,
        "Installation was successful.",
        "success"
      );
    }

    if (item.command.status === "done" && item.command.name === "upgrade") {
      notify(`${title} ${versionStr}`, "Upgrade was successful.");
    } else if (
      item.command.status === "done" &&
      item.command.name === "uninstall"
    ) {
      notify(
        `${title} ${versionStr}`,
        "Uninstallation was successful.",
        "success"
      );
    } else if (
      item.command.status === "working" &&
      item.command.name === "install"
    ) {
      notify(`${title} ${versionStr}`, "Installation has started.", "info");
    } else if (
      item.command.status === "working" &&
      item.command.name === "upgrade"
    ) {
      notify(`${title} ${versionStr}`, "Upgrade has started.", "info");
    } else if (
      item.command.status === "working" &&
      item.command.name === "uninstall"
    ) {
      notify(`${title} ${versionStr}`, "Uninstallation has started.", "info");
    } else if (
      item.command.status === "failed." &&
      item.command.name === "uninstall"
    ) {
      notify(`${title} ${versionStr}`, "Uninstallation failed.", "danger", 0);
    } else if (
      item.command.status === "failed." &&
      item.command.name === "install"
    ) {
      notify(`${title} ${versionStr}`, "Installation failed.", "danger", 0);
    } else if (
      item.command.status === "failed." &&
      item.command.name === "upgrade"
    ) {
      notify(`${title} ${versionStr}`, "Upgrade failed.", "danger", 0);
    }
  }
}

export function notify(title, text, type, duration, speed) {
  Vue.notify({
    group: "all",
    title: title || "",
    text: text || "",
    duration: duration || 10000,
    speed: speed || 200,
    type: type || "success"
  });
}
